import { useMemo } from 'react';
import type { TMessageLogicResult } from './message.types';

export const useMessageLogic = (): TMessageLogicResult => {
	const today = useMemo(() => new Date(), []);

	return { today };
};
